<template>
  <Layout style="height: 100%"
          class="main">
    <Sider hide-trigger
           collapsible
           :width="256"
           :collapsed-width="64"
           v-model="collapsed"
           class="left-sider"
           :style="{overflow: 'hidden'}">
      <side-menu accordion
                 ref="sideMenu"
                 :active-name="$route.name"
                 :collapsed="collapsed"
                 @on-select="turnToPage"
                 :menu-list="menuList">
        <!-- 需要放在菜单上面的内容，如Logo，写在side-menu标签内部，如下 -->
        <div class="logo-con">
          <!-- <img v-show="!collapsed" :src="maxLogo" key="max-logo" /> -->
          <span v-show="!collapsed"
                style="font-size: 26px; color: #ffffff; margin-left: 14px;">
            {{ oem.name || '' }}连锁店后台
            <span style="color:red;font-size:18px;">{{versionName}}</span>
          </span>
          <img v-show="collapsed"
               :src="minLogo"
               key="min-logo" />
        </div>
      </side-menu>
    </Sider>
    <Layout>
      <Header class="header-con">
        <header-bar :collapsed="collapsed"
                    @on-coll-change="handleCollapsedChange">
          <user :message-unread-count="unreadCount"
                :user-avator="userAvator" />
          <fullscreen v-model="isFullscreen"
                      style="margin-right: 10px;" />
          <Dropdown trigger="click"
                    placement="bottom-end"
                    @on-click="onSelectChainStore">
            <a href="javascript:void(0)"
               class="shopName">
              <Icon type="ios-home" /> {{ shopInfo && shopInfo.name || '未选择连锁店' }}
              <Icon type="ios-arrow-down"></Icon>
            </a>
            <DropdownMenu slot="list"
                          class="switchShop">
              <h3 style="text-indent: 15px">切换连锁店</h3>
              <DropdownItem :name="store.id"
                            class="switchShopItem"
                            v-for="store in chain_stores"
                            :key="store.id">{{ store.name }}</DropdownItem>
            </DropdownMenu>
          </Dropdown>
          {{this.me.mobile}}
        </header-bar>
      </Header>
      <Content class="main-content-con">
        <Layout class="main-layout-con">
          <div class="tag-nav-wrapper">
            <tags-nav :value="$route"
                      @input="handleClick"
                      :list="tagNavList"
                      @on-close="handleCloseTag" />
          </div>
          <Content class="content-wrapper">
            <keep-alive :include="cacheList">
              <router-view v-if="initialized" />
            </keep-alive>
            <ABackTop :height="100"
                      :bottom="80"
                      :right="50"
                      container=".content-wrapper"></ABackTop>
          </Content>
        </Layout>
      </Content>
    </Layout>
  </Layout>
</template>
<script>
import SideMenu from './components/side-menu'
import HeaderBar from './components/header-bar'
import TagsNav from './components/tags-nav'
import User from './components/user'
import ABackTop from './components/a-back-top'
import Fullscreen from './components/fullscreen'
import { mapMutations, mapState, mapActions, mapGetters } from 'vuex'
import { getNewTagList, routeEqual } from '@/libs/util'
import routers from '@/router/routers'
import minLogo from '@/assets/images/logo-min.jpg'
import maxLogo from '@/assets/images/logo.jpg'
import './main.less'
export default {
  name: 'Main',
  components: {
    SideMenu,
    HeaderBar,
    TagsNav,
    Fullscreen,
    User,
    ABackTop
  },
  data () {
    return {
      initialized: false,
      shopInfo: null,
      versionName: process.env.VUE_APP_ENV === 'production' ? '' : '测试版',
      collapsed: false,
      minLogo,
      maxLogo,
      isFullscreen: false
    }
  },
  computed: {
    ...mapState('chain_store', ['chain_stores']),
    ...mapGetters('editor', ['me']),
    ...mapState('oem', ['oem']),
    tagNavList () {
      return this.$store.state.tagNavList
    },
    tagRouter () {
      return this.$store.state.tagRouter
    },
    userAvator () {
      return this.me.avator
    },
    cacheList () {
      const list = [
        'ParentView',
        ...(this.tagNavList.length
          ? this.tagNavList
            .filter(item => !(item.meta && item.meta.notCache))
            .map(item => item.name)
          : [])
      ]
      return list
    },
    menuList () {
      return this.$store.getters.menuList
    },
    local () {
      return this.$store.state.local
    },
    hasReadErrorPage () {
      return this.$store.state.hasReadErrorPage
    },
    unreadCount () {
      return this.$store.state.editor.unreadCount
    }
  },
  async created () {
    await this.fetchChainStores({ per: 65535 })
    this.checkChainStoreId();
  },
  methods: {
    ...mapActions('editor', [
      'getUserInfo',
      'logout',
      'change_pwd',
      'getUnreadMessageCount'
    ]),
    ...mapActions('chain_store', {
      fetchChainStores: 'index',
    }),
    ...mapMutations([
      'setBreadCrumb',
      'setTagNavList',
      'addTag',
      'setHomeRoute',
      'closeTag'
    ]),
    checkChainStoreId () {
      const id = localStorage.getItem('SHOPID');
      let shopInfo = this.chain_stores.find(i => i.id == id);
      if (!shopInfo) {
        shopInfo = this.chain_stores[0] || {};
        localStorage.setItem('SHOPID', shopInfo.id);
      }
      this.shopInfo = shopInfo;
      this.initialized = true;
    },
    onSelectChainStore (shop_id) {
      localStorage.setItem('SHOPID', shop_id)
      this.checkChainStoreId()
      this.$nextTick(() => {
        location.reload();
      });
    },
    turnToPage (route) {
      let { name, params, query } = {}
      if (typeof route === 'string') name = route
      else {
        name = route.name
        params = route.params
        query = route.query
      }
      if (name.indexOf('isTurnByHref_') > -1) {
        window.open(name.split('_')[1])
        return
      }
      this.$router.push({
        name,
        params,
        query
      })
    },
    handleCollapsedChange (state) {
      this.collapsed = state
    },
    handleCloseTag (res, type, route) {
      if (type !== 'others') {
        if (type === 'all') {
          this.turnToPage(this.$config.homeName)
        } else {
          if (routeEqual(this.$route, route)) {
            this.closeTag(route)
          }
        }
      }
      this.setTagNavList(res)
    },
    handleClick (item) {
      this.turnToPage(item)
    }
  },
  watch: {
    $route (newRoute) {
      const { name, query, params, meta } = newRoute
      this.addTag({
        route: { name, query, params, meta },
        type: 'push'
      })
      this.setBreadCrumb(newRoute)
      this.setTagNavList(getNewTagList(this.tagNavList, newRoute))
      this.$refs.sideMenu.updateOpenName(newRoute.name)
    }
  },
  mounted () {
    /**
     * @description 初始化设置面包屑导航和标签导航
     */
    this.setTagNavList()
    this.setHomeRoute(routers)
    const { name, params, query, meta } = this.$route
    this.addTag({
      route: { name, params, query, meta }
    })
    this.setBreadCrumb(this.$route)
    // 如果当前打开页面不在标签栏中，跳到homeName页
    if (!this.tagNavList.find(item => item.name === this.$route.name)) {
      this.$router.push({
        name: this.$config.homeName
      })
    }
    // 获取未读消息条数
    this.getUnreadMessageCount()
    this.getUserInfo()
  }
}
</script>

<style lang="scss" scoped>
.shopName {
  font-weight: bold;
  color: #444;
  background: #f5f5f5;
  margin: 0 12px;
  padding: 5px;
  &:before {
    content: "当前正在操作：";
  }
}

.switchShop {
  width: 250px;
  padding: 0 12px;
  h3 {
    line-height: 1.5;
    margin: 10px 0;
  }
  &Item {
    line-height: 2;
    font-weight: 14px;
    &:nth-last-of-type(n + 2) {
      border-top: 1px dashed #f5f5f5;
    }
  }
}
</style>